var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('simple-date-select',{on:{"check":_vm.check}}),_c('value-matching',{on:{"check":_vm.check}}),_c('local-setting',{on:{"check":_vm.check}}),_c('range-setting',{on:{"check":_vm.check}}),_c('select-example',{on:{"check":_vm.check}}),_c('props-setting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }